import { render, staticRenderFns } from "./CampaignCostTemplateForm.vue?vue&type=template&id=f65166ae&scoped=true&"
import script from "./CampaignCostTemplateForm.vue?vue&type=script&lang=js&"
export * from "./CampaignCostTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65166ae",
  null
  
)

export default component.exports